/* eslint-disable */
/* cityform v2 — data augmentation
   The v1 catalogue in data.js is a flat record per city. v2 marketing
   leans much harder on the actual rendered photographs (on-base render,
   eye-level shot, top-down, label macro), so each city now carries:

     - photos[]   : ordered for the hero gallery (on-base first)
     - on_base    : the canonical "model sitting on its base" render
     - wireframe  : the wireframe render
     - model_glb  : optional GLB for the 3D viewer (Sheffield only for now)

   We mutate window.CATALOG in place so the rest of the storefront
   (search, atlas pins, product page) keeps working unchanged.
*/

(function () {
  const ASSETS = {
    sheffield: {
      photos: [
        'assets/products/sheffield_on_base.png',
        'assets/products/sheffield_eyelevel.jpeg',
        'assets/products/sheffield_3q.jpeg',
        'assets/products/sheffield_topdown.jpeg',
        'assets/products/sheffield_relief.jpeg',
        'assets/products/sheffield_corner.jpeg',
        'assets/products/sheffield_label.jpeg',
      ],
      on_base:   'assets/products/sheffield_on_base.png',
      wireframe: 'assets/products/sheffield_wireframe.png',
      model_glb: 'assets/products/sheffield.glb',
    },
    bath: {
      photos: ['assets/products/bath_on_base.png', 'assets/products/bath_preview.png'],
      on_base: 'assets/products/bath_on_base.png',
    },
    cambridge: {
      photos: ['assets/products/cambridge_on_base.png', 'assets/products/cambridge_preview.png'],
      on_base: 'assets/products/cambridge_on_base.png',
    },
    edinburgh: {
      photos: ['assets/products/edinburgh_castle_on_base.png', 'assets/products/edinburgh_on_base.png', 'assets/products/edinburgh_preview.png'],
      on_base: 'assets/products/edinburgh_castle_on_base.png',
    },
    whitby: {
      photos: [
        'assets/products/whitby_on_base_v2.png',
        'assets/products/whitby_hero.jpg',
        'assets/products/whitby_3q.jpg',
        'assets/products/whitby_lifestyle.jpg',
        'assets/products/whitby_top.jpg',
        'assets/products/whitby_label.jpg',
      ],
      on_base: 'assets/products/whitby_on_base_v2.png',
    },
  };

  // Re-runnable: app-v2.jsx swaps window.CATALOG for the live admin
  // catalogue after fetch, then calls this to re-apply the curated v2
  // assets (bundled Sheffield GLB, on-base renders). Reads CATALOG
  // fresh each call rather than closing over a stale reference.
  function applyV2Catalog() {
    const C = window.CATALOG;
    if (!Array.isArray(C)) return;
    C.forEach((c) => {
      // Shopify handles are "sheffield-citycentre"; ASSETS is keyed by short
      // city name ("sheffield"). Try both so curated photos/GLB still apply.
      const a = ASSETS[c.id] || ASSETS[(c.id || '').split('-')[0]];
      if (!a) return;
      if (a.photos)    c.photos    = a.photos;
      if (a.on_base)   c.on_base   = a.on_base;
      if (a.wireframe) c.wireframe = a.wireframe;
      if (a.model_glb) c.model_glb = a.model_glb;
      // primary photo (used by atlas / cards) — prefer the on-base render
      if (a.on_base) c.photo = a.on_base;
    });
  }

  window.__applyV2Catalog = applyV2Catalog;
  applyV2Catalog();
})();
